import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  Box,
  Button,
  Collapse,
  Divider,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrder, updateOrderStatus } from "../../redux/features/orderSlice"; // Import the updateOrderStatus action

const tabData = [
  { label: "Processing", value: "Pending" },
  { label: "Shipped", value: "Shipped" },
  { label: "Completed", value: "Completed" },
  { label: "Canceled", value: "Canceled" },
];

export const MyOrders = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("Pending");
  const [activeRow, setActiveRow] = useState("");
  const [open, setOpen] = useState(false);

  const me = useSelector((state) => state.login.me);
  const orders = useSelector((state) => state.order.order);

  useEffect(() => {
    if (me?.id) {
      dispatch(
        getOrder({
          params: {
            filters: {
              status: {
                $eq: activeTab,
              },
            },
            user_id: me?.id,
            populate:
              "order_items.product.gallery,order_items.variation.product.gallery",
          },
        })
      );
    }
  }, [activeTab, dispatch, me?.id]);

  const handleOpenProducts = (id) => {
    setOpen(() => (id === activeRow ? !open : true));
    setActiveRow(id);
  };

  const handleCancelOrder = (orderId) => {
    dispatch(updateOrderStatus({ orderId, status: "Canceled" }));
    setActiveTab("Canceled");
  };

  return (
    <Paper className="p-4">
      <Typography variant="h6" className="mb-4">
        Order History
      </Typography>
      <Divider sx={{ my: 1 }} />
      {tabData.map((tab) => (
        <button
          key={tab.value}
          className={`px-4 py-2 -mb-px text-sm font-medium border-b-4 w-fit ${
            activeTab === tab.value
              ? "border-black text-black"
              : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
          }`}
          onClick={() => setActiveTab(tab.value)}
        >
          {tab.label}
        </button>
      ))}
      <Box className="mt-4">
        {orders?.length ? (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {orders?.map((order) => (
                  <>
                    <TableRow key={order?.id}>
                      <TableCell>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => handleOpenProducts(order?.id)}
                        >
                          {open && activeRow === order?.id ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell className="uppercase">
                        {order?.order_id}
                      </TableCell>
                      <TableCell>
                        {moment(order?.created_at).format("DD MMM, YYYY")}
                      </TableCell>
                      <TableCell>Rs. {order?.total_price}</TableCell>
                      <TableCell>{order?.status}</TableCell>
                      <TableCell>
                        {order?.status === "Pending" && (
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() => handleCancelOrder(order?.id)}
                          >
                            Cancel
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={6}
                      >
                        <Collapse
                          in={open && activeRow === order?.id}
                          unmountOnExit
                        >
                          <Box margin={1}>
                            <Typography
                              variant="h6"
                              gutterBottom
                              component="div"
                            >
                              Order Products
                            </Typography>
                            <Table size="small" aria-label="order-items">
                              <TableHead>
                                <TableRow>
                                  <TableCell></TableCell>
                                  <TableCell>Product Name</TableCell>
                                  <TableCell>Quantity</TableCell>
                                  <TableCell>Price</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {order?.order_items?.map((item) => (
                                  <TableRow key={item?.id}>
                                    <TableCell>
                                      <img
                                        className="w-20 h-20"
                                        src={
                                          item?.variation
                                            ? item?.variation?.product
                                                ?.gallery?.[0]?.url
                                            : item?.product?.gallery?.[0]?.url
                                        }
                                        alt=""
                                      />
                                    </TableCell>
                                    <TableCell>
                                      {item?.product?.name ||
                                        item?.variation?.product?.name}
                                    </TableCell>
                                    <TableCell>{item?.quantity}</TableCell>
                                    <TableCell>Rs. {item?.price}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div className="flex justify-center w-full">No Orders</div>
        )}
      </Box>
    </Paper>
  );
};
